import truncateHtml from './truncateHtml';
export const utils = {
  truncateHtml
};
flarum.reg.add('fof-synopsis', 'forum/utils', null);